import { matchesBreakpoint, stackWorksFirstCss } from '../surface';

import type { ArmSpec } from '../armRegistry';

export const mobileOwnerReorder: ArmSpec = {
  stamp: (ctx) => {
    if (ctx.cards().length === 0) return { render_state: 'fallback' };

    return {
      render_state: matchesBreakpoint('narrow') ? 'rendered' : 'partial',
    };
  },

  // Injected at every width: the sheet carries its own breakpoints, so a
  // rotation or a resize has to reach the arm without a second pageview.
  onReady: (ctx) => {
    if (ctx.cards().length === 0) return;

    ctx.injectStyles(stackWorksFirstCss(ctx.scope));
  },
};
